export const suffixList = [
  {
    value: 'JR.',
    text: 'Jr.'
  },
  {
    value: 'SR.',
    text: 'Sr.'
  },
  {
    value: 'II',
    text: 'II'
  },
  {
    value: 'III',
    text: 'III'
  },
  {
    value: 'IV',
    text: 'IV'
  },
  {
    value: 'V',
    text: 'V'
  }
];

export const relationshipList = [
  {
    value: 'SPOUSE',
    text: 'Spouse'
  },
  {
    value: 'CHILD',
    text: 'Child'
  },
  {
    value: 'PARENT',
    text: 'Parent'
  },
  {
    value: 'SIBLING',
    text: 'Sibling'
  },
  {
    value: 'OTHER',
    text: 'Other'
  }
];

export const beneficiaryCategory = {
  PERSON: 'PERSON',
  ENTITY: 'ENTITY'
};

export const beneficiaryTypes = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};

const filterByCategory = (beneficiaries, category) => {
  return beneficiaries && beneficiaries.filter(x => x.category === category);
};

const filterByType = (beneficiaries, type) => {
  return beneficiaries && beneficiaries.filter(x => x.beneficiaryType === type);
};

/* eslint-disable no-param-reassign */
export const formatBeneficiariesForList = benes => {
  let beneficiaries = JSON.parse(JSON.stringify(benes));

  beneficiaries.individuals.forEach(bene => {
    bene.category = beneficiaryCategory.PERSON;
  });
  beneficiaries.entities.forEach(bene => {
    bene.category = beneficiaryCategory.ENTITY;
    bene.entityName = bene.name;
  });
  /* eslint-enable no-param-reassign */

  beneficiaries = [...beneficiaries.entities, ...beneficiaries.individuals];

  return {
    primary: filterByType(beneficiaries, beneficiaryTypes.PRIMARY),
    secondary: filterByType(beneficiaries, beneficiaryTypes.SECONDARY)
  };
};

export const formatBeneficiariesForApp = benes => {
  const beneficiaries = JSON.parse(JSON.stringify(benes));

  const individuals = filterByCategory(
    beneficiaries,
    beneficiaryCategory.PERSON
  );
  const entities = filterByCategory(beneficiaries, beneficiaryCategory.ENTITY);
  /* eslint-disable no-param-reassign */
  entities.forEach(bene => {
    bene.name = bene.entityName;
    bene.taxID = bene.taxID.replace(/[^*0-9]/g, '');
    delete bene.entityName;
    delete bene.category;
    delete bene.relationship;
    delete bene.dateOfBirth;
  });
  individuals.forEach(bene => {
    bene.taxID = bene.taxID.replace(/[^*0-9]/g, '');
    delete bene.entityName;
    delete bene.category;
  });
  /* eslint-enable no-param-reassign */
  return {
    beneficiaries: {
      individuals,
      entities
    }
  };
};

export const getAllocationTotal = benes => {
  if (benes.length === 0) return 100;
  return benes.reduce((acc, bene) => acc + Number(bene.percentage), 0);
};

export const getDisplayName = bene => {
  if (bene.category === beneficiaryCategory.PERSON) {
    let str = '';
    if (bene.name.firstName) str += `${bene.name.firstName} `;
    if (bene.name.lastName) str += bene.name.lastName;
    return str;
  }
  return bene.entityName;
};
